<template>
  <CRow>
    <CCol md="2">
      <div role="group" class="form-group filter-group">
        <label>Confirmación:</label>
        <CSelect
          :value="confirm"
          :options="confirmOptions"
          @change="onConfirmChange"
        />
      </div>
    </CCol>

    <CCol md="2">
      <div role="group" class="form-group filter-group">
        <label>Mesa:</label>
        <CSelect
          :value="table"
          :options="tablesOptions"
          @change="onTableChange"
        />
      </div>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'GuestsFilters',
  props: {
    confirm: {
      type: [String, Number],
      default: ''
    },
    table: {
      type: [String, Number],
      default: ''
    },
    confirmOptions: {
      type: Array,
      required: true
    },
    tablesOptions: {
      type: Array,
      required: true
    }
  },
  methods: {
    onConfirmChange(value) {
      this.$emit('update:confirm', this.getSelectValue(value))
    },
    onTableChange(value) {
      this.$emit('update:table', this.getSelectValue(value))
    },
    getSelectValue(value) {
      if (value && value.target) {
        return value.target.value
      }

      return value
    }
  }
}
</script>

<style scoped>
.filter-group {
  margin: -10px 0px 10px;
}
</style>
